import { Columns } from "src/app/shared/interfaces/columns.interface";

export const PreviewDeliveryColumns: Columns = {
  columns: [
    ["Fecha", "retirementDate"],
    ["Código interno", "internalCode"],
    ["N°", "number"],
    ["NOMBRE DE TU PYME", "storeName"],
    ["NOMBRE", "deliveryName"],
    ["TELÉFONO", "deliveryPhone"],
    ["CORREO ELECTRÓNICO", "deliveryEmail"],
    ["DIRECCIÓN", "deliveryAddress"],
    ["NÚMERO DE DEPTO/CASA Y COMENTARIO EN CASO DE HABER", "details"],
    ["Comuna", "deliveryCommuna"],
    ["", "options"],
  ],
  columnsSelect: [
    "retirementDate",
    "internalCode",
    "number",
    "storeName",
    "deliveryName",
    "deliveryPhone",
    "deliveryEmail",
    "deliveryAddress",
    "details",
    "address",
    "deliveryCommuna",
    "options",
  ],
  displayedColumns: [
    "retirementDate",
    "internalCode",
    "number",
    "storeName",
    "deliveryName",
    "deliveryPhone",
    "deliveryEmail",
    "deliveryAddress",
    "details",
    "address",
    "deliveryCommuna",
    "options",
  ],
  480: ["retirementDate", "storeName", "details", "deliveryCommuna", "options"],
  680: ["retirementDate", "storeName", "deliveryPhone", "deliveryEmail", "details", "deliveryCommuna", "options"],
  768: ["retirementDate", "storeName", "deliveryPhone", "deliveryEmail", "details", "deliveryCommuna", "options"],
  1024: ["retirementDate", "number", "storeName", "deliveryCommuna", "options"],
};
